import { Spin } from "antd";
import { type FC } from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";

import { DiffComponent } from "src/app/features/TerminalVersion/components/DiffComponent/DiffComponent";
import type { NoneOwnProps } from "../../../../../core/types";
import { useTerminalVersionLoadQuery } from "../../services/server/TerminalVersionApi";
import type { TerminalVersionEntity } from "../../types/TerminalVersionEntity";

export const TerminalVersionViewDiff: FC<NoneOwnProps> = () => {
    const { id } = useParams();

    const [formData, setFormData] = useState<TerminalVersionEntity>({} as TerminalVersionEntity);

    const { data: loadFormData, isFetching: loadFormIsInProgress } = useTerminalVersionLoadQuery({ entityId: id });

    useEffect(() => {
        if (loadFormData) {
            setFormData(loadFormData);
        }
    }, [loadFormData, setFormData]);

    return (
        <Spin spinning={loadFormIsInProgress}>
            {formData.diffDetails && <DiffComponent key="diffDetails" value={formData.diffDetails} />}
        </Spin>
    );
};
